import { cx } from 'emotion';
import { array, func, string } from 'prop-types';
import React, {
  forwardRef, useRef, useState, useCallback,
} from 'react';
import { createPortal } from 'react-dom';

import { useClickOutside } from '@ezugi/hooks/src/useClickOutside';
import { Icon } from '@ezugi/primitives';
import arrowRight from '@ezugi/static/icons/arrow-right.svg';
import { DeviceInfo } from '@ezugi/utils';

import {
  Container,
  Item,
  Menu,
  activeClassName,
  upClassName,
  downClassName,
} from './style';

const DropdownMenu = forwardRef(({ title, items, onSelect, ...rest }, ref) => {
  const dropdownRef = useRef();
  const titleRef = useRef();
  const [ isActive, setIsActive ] = useState(false);

  const onClick = () => setIsActive((prevValue) => !prevValue);

  const onItemSelect = useCallback((index) => {
    onSelect(index);
    setIsActive((prevValue) => !prevValue);
  }, [ onSelect ]);

  // Close menu on outside click or icon click
  useClickOutside(dropdownRef, (target) => {
    if (!ref.current.contains(target) && !titleRef.current.contains(target)) {
      setIsActive(false);
    }
  });

  return (
    <Container {...rest}>
      <Item onClick={onClick} ref={titleRef}>
        <span>
          {title}
        </span>
        <Icon
          size={20}
          svg={arrowRight}
          fill="#FFF"
          style={{
            marginLeft: '5px',
          }}
          className={isActive ? upClassName : downClassName}
        />
      </Item>
      {ref
        && ref.current
        && createPortal(
          <Menu
            ref={dropdownRef}
            className={cx({ [activeClassName]: isActive })}
            style={{
              transform: DeviceInfo.isHandheld
                ? `translateY(calc(${
                  titleRef.current && titleRef.current.getBoundingClientRect().y
                }px - ${
                  ref.current && ref.current.getBoundingClientRect().y
                }px - 10px - 100%))`
                : 'initial',
            }}
            isHandheld={DeviceInfo.isHandheld}
          >
            <ul>
              {items.map((item, index) => (
                <Item key={item} onClick={() => onItemSelect(index)} isSelected={item === title}>
                  <span>
                    {item}
                  </span>
                </Item>
              ))}
            </ul>
          </Menu>,
          ref.current
        )}
    </Container>
  );
});

DropdownMenu.displayName = 'DropdownMenu';

DropdownMenu.propTypes = {
  title: string,
  items: array,
  onSelect: func,
};

export default DropdownMenu;
